type SizeProps = {
  width?: string
  height?: string
}

const Spacer = (props: SizeProps) => {
  const { width, height = '1rem' } = props

  let style: React.CSSProperties = {};

  // horizontal spacer
  if (width) {
    style.display = 'inline-block';
    style.minWidth = width;
  }

  // vertical spacer (default behaviour)
  if (height) {
    style.minHeight = height;
  }

  return <div style={style} />;
};

export default Spacer;
